import pinia from "stores";
import { useAuthenticationStore } from 'stores/authenticationStore'
import { useEmployeeStore } from 'stores/employeeStore'
import Entity from "../components/admin/investments/fees/Entity.vue";
import { dynamicImportWithRetry } from '../utils/dynamicImportWithRetry';

const employeeStore = useEmployeeStore(pinia)
const authenticationStore = useAuthenticationStore(pinia)

// PUBLIC - AUTHENTICATION
const Authentication = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-authentication" */ "../components/public/authentication/Index.vue"
  )
);
const Login = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-authentication" */ "../components/public/authentication/UserLogin.vue"
  )
);
const SubmitTotp = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-authentication" */ "../components/public/authentication/SubmitTotp.vue"
  )
);
const RequestPwd = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-authentication" */ "../components/public/authentication/RequestPwd.vue"
  )
);
const UpdatePwd = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-authentication" */ "../components/public/authentication/UpdatePwd.vue"
  )
);
const Unlock = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-authentication" */ "../components/public/authentication/UserUnlock.vue"
  )
);
const PageNotFound = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-authentication" */ "../components/public/PageNotFound.vue"
  )
);

// PRIVATE - EMPLOYEES ----------------------------------------------------------------------------------------------------------------------------------------
const AdminLayout = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/Layout.vue"
  ));
/* children */

const CrmLayout = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/CrmLayout.vue"
  ));
/* CRM children */
const People = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/people/Index.vue"
  ));
const Clients = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/clients/Index.vue"
  ));
const Administrators = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/administrators/Index.vue"
  ));
const BankContacts = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/bank_contacts/Index.vue"
  ));
const Employees = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/employees/Index.vue"
  ));
const Entities = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entities/Index.vue"
  ));
const EntityRelations = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_relations/Index.vue"
  ));
const Accounts = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/accounts/Index.vue"
  ));
const AccountRates = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/account_rates/Index.vue"
  ));
const FeeRates = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/fee_rates/Index.vue"
  ));
const PersonConsultants = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/person_consultants/Index.vue"
  ));
const ContactInformations = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/contact_informations/Index.vue"
  ));
const Deposits = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/deposits/Index.vue"
  ));
const MeetingSummaries = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/meeting_summaries/Index.vue"
  ));
const Ownerships = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/ownerships/Index.vue"
  ));
const Users = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/users/Index.vue"
  ));
const Onboarding = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/onboarding/Index.vue"
  ));
const OnboardingSetup = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/onboarding_setup/Index.vue"
  ));
const AllocationLimits = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/allocation_limit/Index.vue"
  ));
const RiskAssessments = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/risk_assessments/Index.vue"
  ));
const BenchmarkSetups = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_benchmarks/EntityBenchmarkIndex.vue"
  ));
const BenchmarkWeights = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_benchmarks/EntityBenchmarkIndex.vue"
  ));
const InvoiceTypes = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/invoice_types/Index.vue"
  ));
const PersonFamilies = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/person_families/Index.vue"
  ));
const Reports = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/reports/Index.vue"
  ));
const EntityInvoiceTypes = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_invoice_types/Index.vue"
  ));
const EntityCommitments = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_commitments/Index.vue"
  ));
const EntityBenchmarks = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_benchmarks/EntityBenchmarkIndex.vue"
  ));
const EntityCostTypes = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_cost_types/Index.vue"
  ));
const EntityCosts = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_costs/Index.vue"
  ));
const EntityCostNames = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_cost_names/Index.vue"
  ));

// MARKET LAYOUT ----------------------------------------------------------------------------------------------------------------------------------------
const MarketLayout = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/MarketLayout.vue"
  ));
/* Markets children */
const Issues = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/issues/Index.vue"
  ));
const Coracts = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/coracts/Index.vue"
  ));
const Currencies = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/currencies/Index.vue"
  ));
const CurrencyRates = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/currency_rates/Index.vue"
  ));
const Covariances = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/covariances/Index.vue"
  ));
const VehicleCostEstimates = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/vehicle_cost_estimates/Index.vue"
  ));
const EntityVehicleCostEstimates = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/entity_vehicle_cost_estimates/Index.vue"
  ));
const AssetClassGroups = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/asset_class_groups/Index.vue"
  ));
const IssueTaxStructures = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/issue_tax_structures/Index.vue"
  ));

  const IssueFundGroups = () =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/issue_fund_groups/IssueFundGroupIndex.vue"
  );
const Aifs = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/aifs/Index.vue"
  ));
const AifCommitments = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/aif_commitments/Index.vue"
  ));
const AifTransactions = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/aif_transactions/Index.vue"
  ));
const AifCommitmentTransactions = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/aif_commitment_transactions/Index.vue"
  ));
const EntityPrices = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/markets/entity_prices/Index.vue"
  ));

// INVESTMENT LAYOUT ----------------------------------------------------------------------------------------------------------------------------------------
const InvestmentLayout = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/investments/InvestmentLayout.vue"
  ));
/* Investments children (quasi) */
const InvestmentCosts = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/investments/investment_costs/Index.vue"
  ));
const Fees = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/investments/fees/Index.vue"
  ));
const EntityInvoiceFees = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/crm/entity_invoice_fees/Index.vue"
  ));
const ManualFees = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/investments/manual_fees/Index.vue"
  ));
const LossWarningLosses = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/investments/loss_warnings/losses/Index.vue"
  ));
const Investments = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/investments/investments/InvestmentLayout.vue"
  ));
const InvestmentReports = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/investments/investment_reports/Index.vue"
  ));
const Report = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/investments/report/Report.vue"
  ));

// MISC ---------------------------------------------------------------------------------------------------------------------------------------------------------
const MiscLayout = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/MiscLayout.vue"
  ));
/* MISC children */
const Documents = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/documents/Index.vue"
  ));
const DocumentPrivileges = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/document_privileges/Index.vue"
  ));
const LaunderingEvents = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/laundering_events/Index.vue"
  ));
const Events = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/events/Index.vue"
  ));
const EventLoads = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/event_loads/Index.vue"
  ));
const EventLoadLogs = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/event_load_logs/Index.vue"
  ));
const HealthChecks = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/health_checks/Index.vue"
  ));
const Routes = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/routes/Index.vue"
  ));
const ApplicationRecordLogs = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/application_record_logs/Index.vue"
  ));
const SailsLogs = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/sails_logs/Index.vue"
  ));
const SailsLogChecks = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/sails_log_checks/Index.vue"
));
const UpdateMessagePolicies = () => dynamicImportWithRetry(() =>
    import(
        /* webpackChunkName: "group-admin" */ "../components/admin/misc/update_message_policies/Index.vue"
        ));
const SailsLogSubscriptions = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/sails_log_subscriptions/Index.vue"
  ));
const TradeSuggestions = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/trade_suggestions/Index.vue"
  ));
const DataSelectors = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/data_selectors/Index.vue"
  ));
const MailGroups = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/mail_groups/Index.vue"
  ));
const MailGroupUsers = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/mail_groups/Index.vue"
  ));
const MailGroupActions = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/mail_groups/ActionIndex.vue"
  ));
const EventRefundSplits = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/event_refund_splits/EventRefundSplitIndex.vue"
  ));
const Banks = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/banks/BankIndex.vue"
  ));
const BankImportRules = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/bank_import_rules/BankImportRuleIndex.vue"
  ));
const DepositReconciliationHistories = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/deposit_reconciliation_histories/DepositReconciliationHistoryIndex.vue"
  ));
const SailsHelpTexts = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/sails_help_texts/SailsHelpTextIndex.vue"
  ));
const TransactionRules = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/transaction_rules/TransactionRuleIndex.vue"
  ));
const AccountBalances = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/account_balances/AccountBalanceIndex.vue"
  ));
const DepositBalances = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/deposit_balances/DepositBalanceIndex.vue"
  ));
const IsinMappings = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/isin_mappings/IsinMappingIndex.vue"
  ));
const DataStagings = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-admin" */ "../components/admin/misc/data_stagings/Index.vue"
  ));


// PRIVATE - INVESTOR ----------------------------------------------------------------------------------------------------------------------------------------
const InvestorLayout = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/Layout.vue"
  ));
const InvestorHome = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/home/Index.vue"
  ));
const InvestorAccounts = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/accounts/Index.vue"
  ));
const InvestorDeposits = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/deposits/Index.vue"
  ));
const InvestorIssues = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/issues/Index.vue"
  ));
const InvestorInvestments = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/report/Index.vue"
  ));
const InvestorReport = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/report/Report.vue"
  ));
const InvestorDocuments = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/documents/Index.vue"
  ));
const DocumentDownload = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/investor/documents/Download.vue"
  ));
const Reportings = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/admin/misc/reportings/ReportingIndex.vue"
  ));
const ReportingTypes = () => dynamicImportWithRetry(() =>
  import(
    /* webpackChunkName: "group-investor" */ "../components/admin/misc/reportings/ReportingTypeIndex.vue"
  ));

const routes = [
  {
    path: "/",
    component: Authentication,
    children: [
      {
        path: "",
        component: Login,
        name: "login",
      },
      {
        path: "totp",
        name: "totp",
        component: SubmitTotp,
        props: (route) => ({ query: route.query.q }),
      },
      {
        path: "request_password",
        name: "request_password",
        component: RequestPwd,
      },
      {
        path: "update_password",
        name: "update_password",
        component: UpdatePwd,
        props: true,
      },
      {
        path: "unlock",
        name: "unlock",
        component: Unlock,
        props: true,
      },
    ],
  },
  {
    path: "/employee",
    name: "employee",
    component: AdminLayout,
    beforeEnter(to, from, next) {
      if (authenticationStore.current_user_is_employee) {
        next();
      } else {
        // Remember where the user was heading, SubmitTotp sends them there once
        // logged in. `this` is not a component in a route guard, so anything but
        // `next()` here breaks the router on a deep link (blank page).
        employeeStore.SET_LOGIN_REDIRECT_PATH(to.fullPath);
        next("/");
      }
    },
    children: [
      {
        component: CrmLayout,
        label: "CRM",
        name: "crm",
        path: "/employee/crm",
        children: [
          {
            component: Clients,
            label: "Kunder",
            name: "clients-default",
            path: "",
          },
          {
            component: People,
            label: "Personer",
            name: "people",
            path: "/employee/crm/people/:id?",
            props: true,
          },
          {
            component: Clients,
            label: "Kunder",
            name: "clients",
            path: "/employee/crm/clients/:id?",
            props: true,
          },
          {
            component: Administrators,
            label: "Administratorer",
            name: "administrators",
            path: "/employee/crm/administrators/:id?",
            props: true,
            index_component: false,
          },
          {
            component: Employees,
            label: "Kollegaer",
            name: "employees",
            path: "/employee/crm/employees/:id?",
            props: true,
            index_component: false,
          },
          {
            component: BankContacts,
            label: "Bank kontakter",
            name: "bank_contacts",
            path: "/employee/crm/bank_contacts/:id?",
            props: true,
            index_component: false,
          },
          {
            component: Users,
            label: "Brugere",
            name: "users",
            path: "/employee/crm/users/:id?",
          },
          {
            component: PersonConsultants,
            label: "Rådgiver kunde relationer",
            name: "person_consultants",
            path: "/employee/crm/person_consultants",
          },
          {
            component: ContactInformations,
            label: "Kontaktinformationer",
            name: "contact_informations",
            path: "/employee/crm/contact_informations",
          },
          {
            component: Ownerships,
            label: "Ejerskaber",
            name: "ownerships",
            path: "/employee/crm/ownerships",
          },
          {
            component: Entities,
            label: "Mandater",
            name: "entities",
            path: "/employee/crm/entities/:id?",
            props: true,
          },
          {
            component: EntityRelations,
            label: "Mandatrealtioner",
            name: "entity_relations",
            path: "/employee/crm/entity_relations",
          },
          {
            component: FeeRates,
            label: "Honorarsatser",
            name: "fee_rates",
            path: "/employee/crm/fee_rates",
          },
          {
            component: Accounts,
            label: "Konti",
            name: "accounts",
            path: "/employee/crm/accounts/:id?",
            props: true,
          },
          {
            component: AccountRates,
            label: "Kontorenter",
            name: "account_rates",
            path: "/employee/crm/account_rates",
          },
          {
            component: Deposits,
            label: "Depoter",
            name: "deposits",
            path: "/employee/crm/deposits/:id?",
            props: true,
          },
          {
            component: MeetingSummaries,
            label: "Mødereferater",
            name: "meeting_summaries",
            path: "/employee/crm/meeting_summaries",
          },
          {
            component: Onboarding,
            label: "Onboarding",
            name: "onboarding",
            path: "/employee/crm/onboarding",
          },
          {
            component: OnboardingSetup,
            label: "Onboarding setup",
            name: "onboarding_setup",
            path: "/employee/crm/onboarding_setup",
          },
          {
            component: AllocationLimits,
            label: "Mandatgrænser",
            name: "allocation_limits",
            path: "/employee/crm/allocation_limits",
          },
          {
            component: RiskAssessments,
            label: "KYC risikovurderinger",
            name: "risk_assessments",
            path: "/employee/crm/risk_assessments/:id?",
          },
          {
            component: InvoiceTypes,
            label: "Fakturamodeller",
            name: "invoice_types",
            path: "/employee/crm/invoice_types/:id?",
          },
          {
            component: PersonFamilies,
            label: "Familier",
            name: "person_families",
            path: "/employee/crm/person_families/:id?",
          },
          {
            component: Reports,
            label: "Rapporter",
            name: "reports",
            path: "/employee/crm/reports/",
          },
          {
            component: DocumentDownload,
            label: "Donwload rapport",
            name: "download_document",
            path: "download_document/:id?",
            props: true,
          },
          {
            component: EntityInvoiceTypes,
            label: "Mandatfakturering",
            name: "entity_invoice_types",
            path: "/employee/crm/entity_invoice_types/:id?",
          },
          {
            component: EntityCommitments,
            label: "Tilsagn",
            name: "entity_commitments",
            path: "/employee/crm/entity_commitments/:id?",
          },
          {
            component: EntityBenchmarks,
            label: "Benchmark pr. mandat",
            name: "entity_benchmarks",
            path: "/employee/crm/entity_benchmarks/:id?",
          },
          {
            component: EntityCostTypes,
            label: "Omkostningstyper pr. mandat",
            name: "entity_cost_types",
            path: "/employee/crm/entity_cost_types/:id?",
            props: true,
          },
          {
            component: EntityCosts,
            label: "Omkostninger pr. mandat",
            name: "entity_costs",
            path: "/employee/crm/entity_costs/:id?",
            props: true,
          },
          {
            component: EntityCostNames,
            label: "Omkostningsnavne pr. mandat",
            name: "entity_cost_names",
            path: "/employee/crm/entity_cost_names/:id?",
            props: true,
          },
        ],
      },
      {
        component: InvestmentLayout,
        label: "Investeringer",
        name: "investment_layout",
        path: "/employee/investments",
        children: [
          {
            component: InvestmentCosts,
            label: "Indirekte Investeringsomkostninger",
            name: "investment_costs",
            path: "/employee/investments/investment_costs",
            props: true,
          },
          {
            component: Fees,
            label: "Honorarer",
            name: "fees",
            path: "/employee/investments/fees/:id?",
            props: true,
          },
          {
            component: EntityInvoiceFees,
            label: "Honorarer",
            name: "entity_invoice_fees",
            path: "/employee/crm/entity_invoice_fees/",
            props: true,
          },
          {
            component: ManualFees,
            label: "Manuelle honorarer",
            name: "manual_fees",
            path: "/employee/investments/manual_fees/:id?",
            props: true,
          },
          {
            component: LossWarningLosses,
            label: "Tabsadvarsler",
            name: "loss_warning_losses",
            path: "/employee/investments/loss_warnings/losses/:id?",
            props: true,
          },
          {
            component: InvestmentReports,
            label: "Gemte investerigsrapporter",
            name: "investment_reports",
            path: "/employee/investments/investment_reports",
          },
          {
            component: Investments,
            label: "Investeringer",
            name: "investments",
            path: "/employee/investments/investments",
          },
          {
            component: Report,
            label: "Rapport",
            name: "report",
            path: "/employee/investments/report/:id?",
            // alias:"/employee/investments/report/:id?",
            props: true,
          },
        ],
      },
      {
        component: MarketLayout,
        label: "Investeringer",
        name: "markets_layout",
        path: "/employee/markets",
        children: [
          {
            component: Issues,
            label: "Værdipapirer",
            name: "issues",
            path: "/employee/markets/issues/:id?",
            props: true,
          },
          {
            component: Coracts,
            label: "Corporate Actions",
            name: "coracts",
            path: "/employee/markets/coracts/:id?",
            props: true,
          },
          {
            component: Covariances,
            label: "Kovariation",
            name: "covariances",
            path: "/employee/markets/covariances",
          },
          {
            component: Currencies,
            label: "Valuta",
            name: "currencies",
            path: "/employee/markets/currencies/:id?",
            props: true,
          },
          {
            component: CurrencyRates,
            label: "Investeringer",
            name: "currency_rates",
            path: "/employee/markets/currency_rates",
          },
          {
            component: VehicleCostEstimates,
            label: "VP omkostningssatser",
            name: "vehicle_cost_estimates",
            path: "/employee/markets/vehicle_cost_estimates/:id?",
            props: true,
          },
          {
            component: EntityVehicleCostEstimates,
            label: "Specifikke refusionssatser",
            name: "entity_vehicle_cost_estimates",
            path: "/employee/markets/entity_vehicle_cost_estimates/:id?",
            props: true,
          },
          {
            component: AssetClassGroups,
            label: "Aktivklasse undergrupper",
            name: "asset_class_groups",
            path: "/employee/markets/asset_class_groups/:id?",
            props: true,
          },
          {
            component: IssueTaxStructures,
            label: "Skattekoder",
            name: "issue_tax_structures",
            path: "/employee/markets/issue_tax_structures/:id?",
            props: true,
          },
          {
            component: IssueFundGroups,
            label: "Fondsgrupper",
            name: "issue_fund_groups",
            path: "/employee/markets/issue_fund_groups/:id?",
            props: true,
          },
          {
            component: Aifs,
            label: "Alternative investeringsfonde",
            name: "aifs",
            path: "/employee/markets/aifs",
          },
          {
            component: AifCommitments,
            label: "AIF tilsagn",
            name: "aif_commitments",
            path: "/employee/markets/aif_commitments",
          },
          {
            component: AifTransactions,
            label: "AIF transaktioner",
            name: "aif_transactions",
            path: "/employee/markets/aif_transactions",
          },
          {
            component: AifCommitmentTransactions,
            label: "AIF tilsagnstransaktioner",
            name: "aif_commitment_transactions",
            path: "/employee/markets/aif_commitment_transactions",
          },
          {
            component: EntityPrices,
            label: "Mandatkurser",
            name: "entity_prices",
            path: "/employee/markets/entity_prices",
          },
        ],
      },
      {
        component: MiscLayout,
        label: "Diverse",
        name: "misc_layout",
        path: "/employee/misc",
        children: [
          {
            component: Documents,
            label: "Dokumenter",
            name: "documents",
            path: "/employee/misc/documents/:id?",
            props: true,
          },
          {
            component: DocumentPrivileges,
            label: "Dokument privilegier",
            name: "document_privileges",
            path: "/employee/misc/document_privileges",
          },
          {
            component: LaunderingEvents,
            label: "Transaktionshvidvask",
            name: "laundering_events",
            path: "/employee/misc/laundering_events",
          },
          {
            component: Events,
            label: "Transaktioner",
            name: "events",
            path: "/employee/misc/events/:id?",
            props: true,
          },
          {
            component: EventLoads,
            label: "Transaktioner - import",
            name: "event_loads",
            path: "/employee/misc/event_loads/:id?",
            props: true,
          },
          {
            component: EventLoadLogs,
            label: "Transaktioner - import log",
            name: "event_load_logs",
            path: "/employee/misc/event_load_logs/:id?",
            props: true,
          },
          {
            component: ApplicationRecordLogs,
            label: "Logposter",
            name: "application_record_logs",
            path: "/employee/misc/application_record_logs",
          },
          {
            component: SailsLogs,
            label: "Systemlog",
            name: "sails_logs",
            path: "/employee/misc/sails_logs",
          },
          {
            component: SailsLogChecks,
            label: "Systemlog opsætning",
            name: "sails_log_checks",
            path: "/employee/misc/sails_log_checks",
          },
          {
            component: SailsLogSubscriptions,
            label: "Systemlog modtagere",
            name: "sails_log_subscriptions",
            path: "/employee/misc/sails_log_subscriptions",
          },
          {
            component: TradeSuggestions,
            label: "Handelsforslag",
            name: "trade_suggestions",
            path: "/employee/misc/trade_suggestions",
          },
          {
            component: HealthChecks,
            label: "Systemhelbed",
            name: "health_checks",
            path: "/employee/misc/health_checks",
          },
          {
            component: Routes,
            label: "Ruter",
            name: "routes",
            path: "/employee/misc/routes",
          },
          {
            component: Reportings,
            label: "Rapporteringer",
            name: "reportings",
            path: "/employee/misc/reportings",
          },
          {
            component: ReportingTypes,
            label: "Rapporteringstyper",
            name: "reportingTypes",
            path: "/employee/misc/reporting_types",
          },
          {
            component: DataSelectors,
            label: "Dataudvalg",
            name: "data_selectorrs",
            path: "/employee/misc/data_selectors",
          },
          {
            component: MailGroups,
            label: "Mailgrupper",
            name: "mail_groups",
            path: "/employee/misc/mail_groups",
          },
          {
            component: MailGroupUsers,
            label: "Mailgruppebrugere",
            name: "mail_group_users",
            path: "/employee/misc/mail_group_users",
          },
          {
            component: MailGroupActions,
            label: "Mailgruppehandlinger",
            name: "mail_group_actions",
            path: "/employee/misc/mail_group_actions",
          },
          {
            component: EventRefundSplits,
            label: "Refusionssplit",
            name: "event_refund_splits",
            path: "/employee/misc/event_refund_splits",
          },
          {
            component: Banks,
            label: "Banker",
            name: "banks",
            path: "/employee/misc/banks"
          },
          {
            component: BankImportRules,
            label: "BankImportRules",
            name: "bank_import_rules",
            path: "/employee/misc/bank_import_rules"
          },
          {
            component: DepositReconciliationHistories,
            label: "DepositReconciliationHistories",
            name: "deposit_reconciliation_histories",
            path: "/employee/misc/deposit_reconciliation_histories"
          },
          {
            component: SailsHelpTexts,
            label: "Hjælpetekster",
            name: "sails_log_texts",
            path: "/employee/misc/sails_help_texts",
          },
          {
            component: TransactionRules,
            label: "Transaktionsregler",
            name: "transaction_rules",
            path: "/employee/misc/transaction_rules",
          },
          {
            component: AccountBalances,
            label: "Kontosaldi",
            name: "account_balances",
            path: "/employee/misc/account_balances",
          },
          {
            component: DepositBalances,
            label: "Depotsaldi",
            name: "deposit_balances",
            path: "/employee/misc/deposit_balances",
          },
          {
            component: IsinMappings,
            label: "isin maping",
            name: "isin_mappings",
            path: "/employee/misc/isin_mappings",
          },
          {
            component: UpdateMessagePolicies,
            label: "Politikker for opdateringer",
            name: "update_message_policies",
            path: "/employee/misc/update_message_policies",
          },
          {
            component: DataStagings,
            label: "Datasamlinger",
            name: "data_stagings",
            path: "/employee/misc/data_stagings",
          },
        ],
      },
    ],
  },
  {
    path: "/investor",
    name: "investor",
    component: InvestorLayout,
    beforeEnter(to, from, next) {
      if (authenticationStore.current_user_is_investor) {
        next();
      } else {
        employeeStore.SET_LOGIN_REDIRECT_PATH(to.fullPath);
        next("/");
      }
    },
    children: [
      {
        component: InvestorReport,
        label: "Rapportering",
        name: 'investor_report',
        path: "",
      },
      {
        component: InvestorHome,
        label: "Hjem",
        name: "investor_home",
        path: "/investor/home",
      },
      {
        component: InvestorAccounts,
        label: "Konto",
        name: "investor_accounts",
        path: "/investor/accounts/:id?",
        props: true,
      },
      {
        component: InvestorDeposits,
        label: "Depot",
        name: "investor_deposits",
        path: "/investor/deposits/:id?",
        props: true,
      },
      {
        component: InvestorIssues,
        label: "Værdipapirer",
        name: "investor_issues",
        path: "/investor/issues/:id?",
        props: true,
      },
      {
        component: InvestorInvestments,
        label: "Rapportering",
        name: "investor_investments",
        path: "/investor/investments",
        props: true,
      },
      {
        component: InvestorReport,
        label: "Rapportering",
        name: "investor_report",
        path: "/investor/report/:id?",
        props: true,
      },
      {
        component: InvestorDocuments,
        label: "Dokumenter",
        name: "investor_documents",
        path: "documents/:id?",
        props: true,
      },
      {
        component: DocumentDownload,
        label: "Download rapport",
        name: "investor_download_document",
        path: "/investor/download_document/:id?",
        props: true,
      },
    ],
  },
  {
    path: '/:catchAll(.*)', // Updated syntax for catch-all
    component: PageNotFound,
  }
];

export default routes;
